(() => {
  let refreshTimeout = null;
  
  document.addEventListener('click', (e) => {
    if (e.target.closest('.quantity__button[name="plus"], .quantity__button[name="minus"], cart-remove-button')) {
      if (refreshTimeout) {
        clearTimeout(refreshTimeout);
      }
      
      refreshTimeout = setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        refreshTimeout = null;
      }, 2000);
    }
  });
})();